import { useTranslation } from "react-i18next";
import { useRouter } from "expo-router";
import { useAuth } from "../../../hooks/useAuth";
import { useUaePassStatus } from "../../../hooks/useUaePassStatus";
import { openUaePassFlow } from "../../../lib/uae-pass-navigation";
import { SocialLoginButton } from "../../auth/SocialLoginButton.web";
import { UaePassDisconnectControl } from "./UaePassDisconnectControl";
import {
  ControlStack,
  ControlCopy,
  ControlSection,
  ControlRow,
  ControlQueryState,
} from "./DataControlParts.web";

export function UaePassPanel({
  onLink,
}: {
  embedded?: boolean;
  onLink?: () => void;
}) {
  const { t } = useTranslation("common");
  const { t: tAuth } = useTranslation("auth");
  const { user } = useAuth();
  const router = useRouter();
  const status = useUaePassStatus(!!user);
  const data = status.data?.uaePassData;
  const fields = [
    [tAuth("uaePass.fieldLabels.fullName"), data?.fullNameEN],
    [tAuth("uaePass.fieldLabels.email"), data?.email],
    [tAuth("uaePass.fieldLabels.mobile"), data?.mobile],
    [tAuth("uaePass.fieldLabels.nationality"), data?.nationalityEN],
  ];
  return (
    <ControlStack>
      <ControlQueryState
        loading={status.isPending}
        error={status.isError}
        retry={status.refetch}
      />
      {status.isSuccess ? (
        status.data?.isLinked ? (
          <>
            <ControlCopy>{t("settings.uaePass.linkedDescription")}</ControlCopy>
            <ControlSection title={tAuth("uaePass.verifiedSectionTitle")}>
              {fields
                .filter(([, value]) => value)
                .map(([label, value]) => (
                  <ControlRow key={label} title={value!} description={label} />
                ))}
            </ControlSection>
            <ControlCopy>{tAuth("uaePass.readOnlyNote")}</ControlCopy>
            <UaePassDisconnectControl />
          </>
        ) : (
          <>
            <ControlCopy>
              {t("settings.uaePass.unlinkedDescription")}
            </ControlCopy>
            <SocialLoginButton
              provider="uae-pass"
              label={t("settings.uaePass.linkAction")}
              onPress={
                onLink ??
                (() => {
                  void openUaePassFlow(router, { mode: "settings_link" });
                })
              }
            />
          </>
        )
      ) : null}
    </ControlStack>
  );
}
